import { createContext, ReactNode } from "react";

export interface ContributionProps {
  id: string;
  variant: "elevated" | "horizontal" | "vertical";
  username: string;
  userAvatarSrc: string;
  contributionTime: string;
  imageSrc?: string;
  imageAlt?: string;
  cardHeading?: string;
  cardDescription?: string | ReactNode;
  showDescription?: boolean;
  showFullTextContent?: boolean;
  commentsCount?: string | number;
  thumbsUpCount?: string | number;
  thumbsDownCount?: string | number;
  shareText?: string;
  showCommentIcon?: boolean;
  isThumbsUp?: boolean;
  isThumbsDown?: boolean;
  isShareIcon?: boolean;
  showTags?: boolean;
  tags?: Array<string>;
  handleMoreOptions?: () => void;
  handleComment?: () => void;
  handleVoteUp?: () => void;
  handleVoteDown?: () => void;
  handleShare?: () => void;
  showImage?: boolean;
  showFooter?: boolean;
  isLoaded: boolean;
  showMoreOptions?: boolean;
  actionList?: ReactNode;
  isVoteActive?: boolean;
  isVoteDisabled?: boolean;
  makeFooterViewOnly?: boolean;
  socialShareTitle?: string;
  socialShareUrl?: string;
  showShareText?: boolean;
  ariaLabelVoteIcon?: string;
  ariaLabelCommentIcon?: string;
  ariaLabelThumbsDownIcon?: string;
  ariaLabelShareIcon?: string;
  isIconButtonPressed?: boolean;
  showBudgeting?: boolean;
  totalFund?: string;
  fundLocale?: string;
  fundedForLocale?: string;
  undoBudgetingLocale?: string;
  hasTotalFunded?: boolean;
  tileBackgroundColor?: string;
  onClick?: () => void;
  headingId?: string;
  descriptionId?: string;
  isBudgetUpdating?: boolean;
  handleBudgeting?: (() => void) | (() => Promise<void>);
  pinType?: string;
  pinColor?: string;
  pinIcon?: ReactNode;
  pinAddress?: string;
  isAddressVisible?: boolean;
  pinImageSrc?: string;
  addonNode?: ReactNode;
  ariaLabelPinIcon?: string;
  hideTile?: boolean;
  cursor?: string;
}

export const ContributionContext =
  createContext<Partial<ContributionProps> | null>(null);
